export default __webpack_public_path__ + "images/product-placeholder.png?24f898d6abf2696c2933e07e93f15307";